<template>
  <!-- 在线咨询表单页 -->
  <div class="zxzxform">
    <div class="zxzxformcont">
      <div class="zxzxheader between">
        <div>在线的律师有 <span>12,596</span> 位</div>
        <div>今日咨询人数：<span>27,672</span> 人</div>
        <div>律师已解答：<span>28,175</span> 问题</div>
      </div>
      <div class="form mt30">
        <div class="formheader text_center">
          <div class="top1">在线咨询</div>
          <div class="top2">
            >>>>> <span>填写问题</span> >>>>> <span>等待律师回复</span> >>>>>
            <span>查看律师解答</span> >>>>> <span>评价律师</span>
          </div>
        </div>
        <div class="formlist" ref="formlist">
          <div v-for="(item, index) in msg" :key="index">
            <div
              class="itemmsg"
              :class="{ left: item.type == 2, right: item.type == 1 }"
            >
              <div class="cover">
                <img
                  v-if="item.type == 2"
                  src="../../assets/zx_consult/kfcover.png"
                />
                <img
                  v-if="item.type == 1"
                  src="../../assets/base/small_rentou.png"
                />
              </div>
              <div class="content">
                <i class="el-icon-caret-bottom jt"></i>
                {{ item.cont }}
              </div>
            </div>
            <div class="encryption center" v-if="index == 1">
              <img src="../../assets/zx_consult/suo.png" alt="" />
              <span>对话已加密，请放心输入</span>
            </div>
          </div>
        </div>
        <div class="formin">
          <div class="inhea between">
            <div class="seleft flex_start">
              <div class="zb">
                <img src="../../assets/zx_consult/zb.png" alt="" />
              </div>
              <div class="addr">
                <select class="seladr">
                  <option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item.label"
                  >
                    {{ item.label }}
                  </option>
                </select>
                <select class="seladr">
                  <option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item.label"
                  >
                    {{ item.label }}
                  </option>
                </select>
                <select class="seladr">
                  <option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item.label"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="anony">
              <input
                class="anonyradig"
                type="radio"
                v-model="anonyradig"
                @click="clirio"
                :checked="anonyradig"
              />
              <span>匿名提交</span>
            </div>
          </div>
          <div>
            <textarea
              class="textarea"
              placeholder="请在此输入您要咨询的问题（至少10个字）..."
              v-model="subtext"
              maxlength="500"
              @keyup.enter="submit"
            ></textarea>
          </div>
          <div class="btn flex_end">
            <div class="sum">{{ textlength }}/500</div>
            <div
              class="submit noact"
              @click="submit"
              :class="{ act: textlength >= 10 }"
            >
              发送
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    msg: [
      {
        type: 2,
        cont:
          "欢迎使用『律观网』在线咨询，当前在线律师12,596，最快2分钟获得解答，继续下一步默认您同意《律观网网络服务使用协议》、《律观网个人信息保护协议及隐私政策》",
      },
      { type: 2, cont: "您好，请问你要咨询什么问题？" },
      { type: 1, cont: "《律观网网络服务使用协议》" },
    ],
    options: [
      { label: "安徽" },
      { label: "安徽" },
      { label: "安徽" },
      { label: "安徽" },
    ],
    anonyradig: true,
    subtext: "",
  }),
  computed: {
    textlength() {
      return this.subtext.split("").length;
    },
  },
  methods: {
    clirio() {
      this.anonyradig = !this.anonyradig;
      console.log(this.anonyradig);
    },
    submit() {
      if (this.textlength <= 10) {
         this.$message({
          message: '最低10个字才能咨询哦',
           center: true,
          type: 'warning'
        });
      }
      if (this.textlength >= 10) {
        console.log("点击了发送个");
        this.pushmsg({ type: 1, cont: this.subtext })
      }
    },
    pushmsg(cont){
      this.msg.push(cont);
        this.subtext = '';
        this.$nextTick(()=>{
          let msg = this.$refs.formlist // 获取对象
          msg.scrollTop = msg.scrollHeight // 滚动高度
        })
    }
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
.zxzxform {
  background-color: #f8f8f8;
  border-top: 1px solid #eee;
  .zxzxformcont {
    width: 900px;
    margin: 0 auto;
    padding: 50px 0;
    .zxzxheader {
      font-size: 18px;
      color: #333333;
      padding: 0 60px;
      span {
        color: #0465ea;
      }
    }
    .form {
      width: 900px;
      height: 650px;
      background: #ffffff;
      box-shadow: 0px 6px 30px 0px rgba(1, 1, 1, 0.08);

      .formheader {
        padding: 12px 0;
        .top1 {
          padding-top: 6px;
          font-size: 24px;
          color: #333333;
        }
        .top2 {
          padding-top: 12px;
          font-size: 14px;
          color: #999999;
          span {
            margin: 0 10px;
          }
        }
      }
      .formlist {
        width: 100%;
        height: 362px;
        background: #f9f9fa;
        padding: 1px 60px;
        overflow-y: auto;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;

        .left {
          > div {
            float: left;
          }
          .content {
            margin-left: 20px;
          }
          .jt {
            position: absolute;
            font-size: 30px;
            transform: rotate(90deg);
            left: -18px;
          }
          &::after {
            content: ".";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
          }
        }
        .right {
          > div {
            float: right;
          }

          .content {
            margin-right: 20px;
          }
          .jt {
            position: absolute;
            font-size: 30px;
            transform: rotate(-90deg);
            right: -18px;
          }
          &::after {
            content: ".";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
          }
        }
        .itemmsg {
          margin-top: 25px;
          .cover {
            img {
              margin-top: 2px;
              width: 42px;
              height: 42px;
              background: #f0f0f0;
              border-radius: 50%;
            }
          }
          .content {
            padding: 10px 15px;
            max-width: 510px;
            position: relative;
            background: #ffffff;
            border-radius: 8px;
            font-size: 14px;
            color: #333333;
            line-height: 24px;
            .jt {
              top: 6px;
              color: #fff;
            }
          }
        }
        .encryption {
          img {
            width: 24px;
            height: auto;
            margin-right: 6px;
          }
          color: #c7c7c7;
          font-size: 14px;
          margin: 30px 0;
        }
      }
      .formin {
        margin-top: 14px;
        padding: 0 36px;
        .inhea {
          .seleft {
            .zb {
              margin-right: 10px;
              img{
                width: 16px;
                height: 22px;
              }
            }
            .addr {
              .seladr {
                width: 84px;
                height: 30px;
                border-color: #ccc;
                color: #999;
                border-radius: 4px;
                margin-right: 8px;
              }
              select:focus {
                outline: none;
              }
            }
          }
          .anony {
            font-size: 16px;
            color: #555555;
            line-height: 24px;
            span {
              margin-left: 8px;
            }
            .anonyradig {
              width: 18px;
              height: 18px;
              appearance: none;
              position: relative;
              top: -1px;
              outline: none;
            }
            .anonyradig:before {
              content: "";
              width: 15px;
              height: 15px;
              border: 1px solid #ff8b3e;
              display: inline-block;
              border-radius: 50%;
              vertical-align: middle;
            }
            .anonyradig:checked:before {
              content: "";
              width: 15px;
              height: 15px;
              border: 1px solid #ff8b3e;
              display: inline-block;
              border-radius: 50%;
              vertical-align: middle;
            }
            .anonyradig:checked:after {
              content: "";
              width: 9px;
              height: 9px;
              text-align: center;
              background: #ff8b3e;
              border-radius: 50%;
              display: block;
              position: absolute;
              top: 4px;
              left: 4px;
            }
            .anonyradig:checked + label {
              color: #ff8b3e;
            }
          }
        }
        .textarea {
          line-height: 24px;
          font-size: 14px;
          outline: none;
          border: none;
          width: 100%;
          height: 110px;
          padding-top: 22px;
          &::placeholder {
            color: #d1d1d1;
          }
        }
        .btn {
          .sum {
            font-size: 14px;
            color: #d1d1d1;
            margin-right: 8px;
          }
          .submit {
            width: 80px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            border-radius: 12px;
            font-size: 14px;
          }
          .noact {
            cursor: pointer;
            background: #f2f2f2;
            color: #555555;
          }
          .act {
            cursor: pointer;
            background: #0465ea;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>